import React from "react";

export function valueToSubmit(value) {
	// Submit form
	return Object.keys(value).map((sectionID) => {
		return {
			id: sectionID,
			data: Object.keys(value[sectionID])
				.filter((key) => value[sectionID][key])
				.map((key) => {
					if (typeof value[sectionID][key] === "object") {
						return {
							id: key,
							value: Object.keys(value[sectionID][key]).map(
								(val) => {
									return {
										id: val,
										value: value[sectionID][key][val],
									};
								}
							),
						};
					}
					return {
						id: key,
						value: value[sectionID][key],
					};
				}),
		};
	});
}

export function previewToValue(previewData) {
	// Preview / Display
	console.log(previewData);
	return previewData.reduce((sections, section) => {
		return {
			...sections,
			[section.id]:
				// section.type === 'mandatorySingleChoice' ?
				// {[section.application.id] : section.application.valueId} : // mandatory single answer
				section.application.reduce((applications, application) => {
					console.log(application);
					return {
						...applications,
						[application.id]:
							section.type === "optionalMultipleChoice"
								? application.choices.reduce(
										(choices, choice) => {
											return {
												...choices,
												[choice.id]: choice.valueId,
											};
										},
										{}
								  )
								: application.valueId ||
								  application.value ||
								  null,
					};
				}, {}),
		};
	}, {});
}
